import styled from 'styled-components';
import Fab from '@mui/material/Fab';
import { makeStyles } from '@mui/styles';
// import IconButton from '@material-ui/core/IconButton';

export const VideoContainer = styled.div`
  display: flex;
  padding: 1rem;
  /* min-height:   ${({ fullWidth }) => (fullWidth ? 'initial' : '250px')}; */
  position: relative;
  /* ${({ fullWidth }) => (fullWidth ? 'width: 100%;' : `margin-right: -50px;`)} */
  width: 100%;
  
    padding: 0 !important;
    margin: 10px 0 0 0 !important;
    display: block !important;
    iframe {
      width: 100% !important;
      // height: 350px !important;

`;

export const CloseBtn = styled(Fab)`
  && {
    right: 10px;
    top: 10px;
    position: absolute;
  }
`;

export const useClasses = makeStyles((theme) => ({
  video: {
    [theme.breakpoints.down('xs')]: {
      width: '250px',
      height: '175px',
    },
  },
}));
